import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../common/EditPage';
import { create, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const CurrencyCreate = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({
        ATRCURNAME: '',
        ATRCURDSCR: '',
        ATRCURRATE: '1.00'
    });
    const [defaultCurrency, setDefaultCurrency] = useState({});
    useEffect(() => {
        getOne('/admin/settings/currencies/', 1).then(response => {
            setDefaultCurrency(response.data.data);
        });
    }, []);
    const handleSave = () => {
        create('/admin/settings/currencies', {data: data}).then(response => {
            toast.success("Currency created successfully", {});
            navigate('/settings/currencies');
        }).catch(error => {
            toast.error("Error creating currency: " + error.message, {});
        });
    }
    const handleCancel = () => {
        navigate('/settings/currencies');
    }
    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create Currency" >
                <EditPagePanel>
                    <EditPageTextField label="ISO Code" id="ATRCURNAME" onChange={ onChange } value={ data.ATRCURNAME } />
                    <EditPageTextField label="Name" id="ATRCURDSCR" onChange={ onChange } value={ data.ATRCURDSCR } />
                    <EditPageTextField label={`Exchange Rate (against ${defaultCurrency?.ATRCURNAME})`} id="ATRCURRATE" onChange={ onChange } value={ data.ATRCURRATE } />
                </EditPagePanel>
            </EditPage>
        </div>
    )
}

export default CurrencyCreate;